import {CellData} from '../../core/models/cell-data';

export class Notification {
    username: string;
    actionId: string;
    actionDes: string;
    timestamp: string;

    target: string;
    dataTarget: string;

    date: string[];
    interval: string[];
    value: string[];
}



// WEBPACK FOOTER //
// ./src/app/shared/models/notification.ts